import { AddressValue } from "$src/domain/core/AddressValue";
import type { ILocalityRepository } from "$src/domain/map/ILocalityRepository";
import { Location } from "$src/domain/map/Location";
import { Road } from "$src/domain/map/Road";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetRoad {
    
    constructor(@inject(ServiceTokens.LocalityRepository) private localityRepository: ILocalityRepository) {}

    async execute(from: Location, address: AddressValue): Promise<Road> {
        var road = await this.localityRepository.getRoadFromPointtoAddress(from, address);
        return road;
    }
}

export const GetRoadToken = Symbol('GetRoadToken');    
